export default __webpack_public_path__ + "static/media/File No. 12.c89d5fc9.pdf";